import type { ReactNode } from 'react'

import { Spacer } from '@/src/elements/spacer/Spacer'

export const ItemSeparatorComponent = (): ReactNode => <Spacer y={3} />
